export default __webpack_public_path__ + "static/media/Regex.400eb3cd.md";